import { render, staticRenderFns } from "./products.page.vue?vue&type=template&id=7b08a92c&scoped=true"
import script from "./products.page.vue?vue&type=script&lang=js"
export * from "./products.page.vue?vue&type=script&lang=js"
import style0 from "./products.page.vue?vue&type=style&index=0&id=7b08a92c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b08a92c",
  null
  
)

export default component.exports